import { SessionStatus } from '@/infra/sse/status'

export type SessionStatusTab = 'active' | 'resumable' | 'parked'

export const SESSION_STATUS_TAB_MAPPING: Record<
  Exclude<SessionStatusTab, 'parked'>,
  readonly SessionStatus[]
> = {
  active: [SessionStatus.RUNNING],
  resumable: [SessionStatus.RESUMABLE],
} as const

export const SESSION_STATUS_TAB_VALUES: readonly SessionStatusTab[] = [
  'active',
  'resumable',
  'parked',
] as const

export const DEFAULT_SESSION_STATUS_TAB: SessionStatusTab = 'active'
